import { useDispatch, useSelector } from 'react-redux';
import { fetchCollectionCatalogItemById } from '../../../../../../redux/actions';
import {
  CollectionCategoryNameText,
  CollectionCategoryWrapper,
  CollectionNameText,
  CollectionWrapper,
} from './AllCollectionsItems.styles';
import { useSSRSelector } from '@/redux/ssrStore';
import { ProductListWrapper } from 'src/components/DesignSystem/Widgets2.0/ProductListWrapper';
import FlatListV2 from 'src/containers/Collections/FlatListV2';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { useRouter } from 'node_modules/next/router';
import { getRoute, PATH } from 'src/utils/routes';
import { useMemo } from 'react';
import { ITEM_ACTIVE_STATUS } from 'src/utils/constants';

function AllCollectionsItems(props) {
  const dispatch = useDispatch();
  const {
    widgetContextState: { isBuilder },
  } = useWidgetDndContextData();

  const { collections, storeData } = useSSRSelector((state) => ({
    collections: state.catalogReducer.collections,
    storeData: state.storeReducer.store,
  }));

  const { collectionCatalogItems } = useSelector((state: any) => ({
    collectionCatalogItems: state.catalogReducer.collectionCatalogItems,
  }));

  /**
   * this function fetches collection category items when data
   * needs to be loaded
   * @param {number} category
   * @param {number} collection
   */

  function loadMoreData(category, collection) {
    if (isBuilder) return;
    if (storeData?.store_id) {
      dispatch(
        fetchCollectionCatalogItemById({
          storeId: storeData.store_id,
          collectionId: collection.id,
          categoryId: category.id,
        })
      );
    }
  }

  /**
   * this function checks collection object for presence of category and its items
   * as it may or may not be there as we call api when we need to show the items
   * @param {number} collectionId
   * @param {number} categoryId
   * @returns {Array}  of items that needs to be rendered in a collection category
   */

  function returnNestedCollectionData(collectionId, categoryId) {
    const collectionIdValue = collectionCatalogItems[collectionId];
    let categoryIdValue = undefined;
    if (collectionIdValue) {
      categoryIdValue = collectionIdValue[categoryId];
    }
    return categoryIdValue;
  }

  return (
    <>
      {collections?.length
        ? collections.map((collection) => (
            <CollectionWrapper
              showSortByDropDown={props?.showSortByDropDown}
              showFilterDrawer={props?.showFilterDrawer}
              key={collection?.id}
            >
              {collection?.categories?.map((category) => (
                <CollectionCategorySection
                  key={category?.id}
                  category={category}
                  collection={collection}
                  loadMoreData={loadMoreData}
                  returnNestedCollectionData={returnNestedCollectionData}
                  storeData={storeData}
                />
              ))}
            </CollectionWrapper>
          ))
        : null}
    </>
  );
}

export default AllCollectionsItems;

const CollectionCategorySection = ({
  category,
  collection,
  loadMoreData,
  storeData,
  returnNestedCollectionData,
}) => {
  const router = useRouter();
  const collectionData = returnNestedCollectionData(collection.id, category.id);

  const handleLoadMore = () => {
    if (collectionData) return;
    loadMoreData(category, collection);
  };

  const CollectionNameTag =
    router.asPath.includes('/shop') || router.asPath.includes('/collections')
      ? CollectionNameText.withComponent('h1')
      : CollectionNameText;

  const productList = useMemo(() => {
    if (!Array.isArray(collectionData) || !collectionData?.length) return [];

    return collectionData
      .filter(
        (data) =>
          data.is_active === ITEM_ACTIVE_STATUS.ACTIVE &&
          (!storeData?.services?.hide_out_of_stock || data?.available)
      )
      .slice(0, 12); // Limit to 12 items
  }, [collectionData, collectionData?.length, storeData?.services?.hide_out_of_stock]);

  function limitProductListItems() {
    return collectionData?.length > 12;
  }

  function routeToCategory() {
    window.location.href = getRoute(
      `${PATH.SHOP}/${category.name}?cid=${category.id}`,
      storeData?.store_info?.domain
    );
  }

  return (
    <FlatListV2 loadMoreData={handleLoadMore}>
      <CollectionCategoryWrapper>
        <CollectionCategoryNameText addBottomSpace>
          <CollectionNameTag>{`${collection.name}  /  `}</CollectionNameTag>
          {category.name}
        </CollectionCategoryNameText>

        <div>
          <ProductListWrapper
            productList={productList}
            oldCardConfigs={{
              showButton: true,
              noTagsReadState: 'fromLength',
            }}
            renderAdvancedCard
            calculateSelfDimensions
          />
          {!!limitProductListItems() && (
            <div className="tw-flex tw-items-center tw-justify-center tw-mt-48">
              <button
                className="tw-cursor-pointer tw-border-none tw-bg-black tw-px-16 tw-py-8 tw-text-white"
                onClick={routeToCategory}
              >
                Show More
              </button>
            </div>
          )}
        </div>
      </CollectionCategoryWrapper>
    </FlatListV2>
  );
};
